<template>
	<card layout="grid" tag="section">
		<template #default>
			<loading v-if="loading"></loading>
			<div v-else>
				<div v-if="!loading && users.length == 0">No partners for this filter</div>
				<div v-else>
					<div class="widget-container">
						<user-intro :userId="u.Id" v-for="u in users" :key="u.Id"></user-intro>
					</div>
				</div>
			</div>
		</template>
	</card>
</template>
<script>
	import { ref, inject, computed, onMounted } from "vue";
	import userIntro from "@/components/webComponents/widget/userIntro/userIntro.vue";
	export default {
		props: {
			adgroup: {
				type: String,
				default: undefined
			},
			filters: {
				type: Object,
				default: () => {
					return {};
				}
			}
		},
		components: {
			userIntro
		},
		setup(props, context) {
			const $json = inject("$json");
			const $http = inject("$http");

			const loading = ref(true);
			const users = ref([]);

			const GetNewUsers = async () => {
				try {
					const resp = await $http.post("/api/v2/widget/newPartners", {
						filter: props.filters?.keys || [],
						adgroup: props.adgroup
					});
					users.value = resp.data;
				} catch (err) {
					console.error(err);
				}
			};

			onMounted(async () => {
				await GetNewUsers();
				loading.value = false;
			});

			return {
				loading,
				users
			};
		}
	};
</script>
